class ClosingsStore {

  constructor() {
    this.bindActions(this.alt.getActions('Closings'));

    this.closingsStatus = {};
    this.errors = {};
  }

  onReadClosingsStatusSuccess(data) {
    this.closingsStatus = data;
    delete this.errors['readClosingsStatus'];
  }

  onReadClosingsStatusFail(error) {
    this.errors['readClosingsStatus'] = error;
  }

}

export default ClosingsStore;



// WEBPACK FOOTER //
// ./app/flux/stores/Closings.js